import React from 'react';

const Loader = () => {
  return (
    <div>
      <span class="loader"></span>
    </div>
  );
};

export default Loader;
